(ns minorodata.connections.sources.google-search-console
  (:require [minorodata.app.utils :as app.utils]))

(def source
  {:enabled      false
   :id           "google-search-console"
   :name         "Google Search Console"
   :description  "Monitor, maintain, and troubleshoot your site's presence in Google Search results"
   :image-source "gsc.png"
   :tags         ["analytics"]

   :preview-formatter
   (fn []
     (str "Authenticated with a Google Service Account"))

   :form
   {:format-for-api
    (fn [data]
      (let [{:keys [name description type client-email client-id
                    private-key private-key-id project-id]} data]
        {:source-type "google-search-console"
         :name        name
         :description description

         :source
         {:credentials {:type type
                        :client_email client-email
                        :client_id client-id
                        :private_key private-key
                        :private_key_id private-key-id
                        :project_id project-id}}}))

    :format-for-inputs
    (fn [data]
      (let [{:keys [source name description]} data
            {:keys [credentials]} source]
        (merge {:name        name
                :description description}
               (select-keys credentials [:type :client-email :client-id :private-key :private-key-id :project-id]))))

    :validate (constantly nil)

    :id :google-search-console-form

    :blocks [{:block-type :input
              :label      "Source name"
              :required   true
              :name       :name
              :value      ""}
             {:block-type :input
              :label      "Description"
              :name       :description
              :value      ""}
             {:content "Authentication"
              :block-type :subtitle}
             {:content "Enter information required to connect to Google Search Console"}
             {:block-type :select
              :label      "Connection type"
              :name       :type
              :required   true
              :disabled   true
              :options    [{:name "Service account" :value "service_account"}]
              :value      "service_account"}
             {:block-type :input
              :label      "Client Email"
              :name       :client-email
              :required   true
              :value      ""}
             {:block-type :input
              :label      "Client ID"
              :name       :client-id
              :required   true
              :value      ""}
             {:block-type :input
              :label      "Private Key"
              :name       :private-key
              :type       :password
              :required   true
              :value      ""}
             {:block-type :input
              :label      "Private Key ID"
              :name       :private-key-id
              :required   true
              :value      ""}
             {:block-type :input
              :label      "Project ID"
              :name       :project-id
              :required   true
              :value      ""}

             {:block-type :submit
              :content    "SAVE"}]}


   :extract-form
   {:format-for-api
    (fn [{:keys [name description status website report action destination-table extract-type]}]
      {:name          name
       :description   description
       :status        status
       :output-tables [destination-table]

       :config
       {:extracts [{:action            action
                    :website           website
                    :report            report
                    :extract-type      extract-type
                    :destination-table destination-table}]}})

    :format-for-inputs
    (fn [data]
      (let [{:extract/keys [name description status config]} data

            extract (get-in config [:extracts 0])]
        (merge
         (select-keys extract [:destination-table :report :action :website :extract-type])
         (app.utils/keep-non-nil-keys
          {:name          name
           :description   description
           :status        status
           :output-tables []}))))

    :validate (constantly nil)

    :id :google-search-console-extract-form

    :blocks [{:block-type :input
              :label      "Extract name"
              :required   true
              :name       :name
              :value      ""}
             {:block-type :input
              :label      "Description"
              :name       :description
              :value      ""}

             {:block-type :select
              :label      "Status"
              :name       :status
              :options    [{:name "Active" :value "active"}
                           {:name "Paused" :value "paused"}]
              :required   true
              :value      "active"}

             {:block-type :subtitle
              :content    "Extract Configuration"}

             {:block-type :input
              :label      "Website"
              :name       :website
              :value      ""}

             {:block-type :select
              :label      "Report"
              :name       :report
              :options    [{:name "Query pages by property" :value "query-pages-by-property"}
                           {:name "Pages by property" :value "pages-by-property"}
                           {:name "Queries by property" :value "queries-by-property"}]
              :required   true
              :value      "query-pages-by-property"}

             {:content [:p "Columns: PROPERTY_URI, DAY, COUNTRY, DEVICE, PAGE, IMPRESSIONS, CLICKS, CTR, POSITION"]
              :conditions [[:eq [:report :value] "pages-by-property"]]}

             {:content [:p "Columns: PROPERTY_URI, DAY, COUNTRY, DEVICE, SEARCH_TERM, IMPRESSIONS, CLICKS, CTR, POSITION"]
              :conditions [[:eq [:report :value] "queries-by-property"]]}

             {:content [:p "Columns: PROPERTY_URI, DAY, COUNTRY, DEVICE, SEARCH_TERM, PAGE, IMPRESSIONS, CLICKS, CTR, POSITION"]
              :conditions [[:eq [:report :value] "query-pages-by-property"]]}

             {:block-type :select
              :label      "Extract type"
              :name       :extract-type
              :options    [{:name "Full"        :value "full-load"}
                           {:name "Incremental" :value "incremental"}]
              :required   true
              :value      "full-load"}

             {:block-type :subtitle
              :content    "Data loading options"}

             {:block-type :select
              :label      "Load method"
              :name       :action
              :options    [{:name "Drop, Create, Load" :value "replace"}
                           {:name "Truncate, Load"     :value "reload"}
                           {:name "Append"             :value "append"}]
              :required   true
              :value      "replace"}

             {:content "Drop table, Create table, load entire table (selected columns)"
              :conditions [[:eq [:action :value] "replace"]]}

             {:content "Truncate table, Load entire table (selected columns)"
              :conditions [[:eq [:action :value] "reload"]]}

             {:content "Load entire table (selected columns) into the destination table no table recreation, no truncation"
              :conditions [[:and [[:action :value] [:extract-type :value]] ["append" "full-load"]]]}

             {:content "Find max record in destination table of specified incremental key. Select rows where results of incremental key greater than max record of incremental key in destination table. Insert rows (selected columns) into the destination table no truncation."
              :conditions [[:and [[:action :value] [:extract-type :value]] ["append" "incremental"]]]}

             {:block-type :subtitle
              :content    "Destination table"}

             {:block-type  :warehouse-destination
              :name        :destination-table}

             {:block-type :submit
              :content    "SAVE"}]}})
